import { useEffect, useState } from 'react'

export const useTimer = (timestampInSeconds: number) => {
	const [timeLeft, setTimeLeft] = useState('')

	useEffect(() => {
		const calculateTimeLeft = () => {
			const now = Date.now()
			const distance = timestampInSeconds * 1000 - now
			const formatTime = (time: number) => String(time).padStart(2, '0')

			if (distance > 0) {
				const hours = Math.floor(distance / (1000 * 60 * 60))
				const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
				const seconds = Math.floor((distance % (1000 * 60)) / 1000)

				setTimeLeft(`${formatTime(hours)}:${formatTime(minutes)}:${formatTime(seconds)}`)
			} else {
				setTimeLeft('00:00:00')
			}
		}

		calculateTimeLeft()
		const intervalId = setInterval(calculateTimeLeft, 1000)

		return () => clearInterval(intervalId)
	}, [timestampInSeconds])

	return timeLeft
}
